export default __webpack_public_path__ + "static/media/GiftCard.7e3a4257.jpg";